import { useQuery } from '@tanstack/react-query';
import { videoService } from '@/services/videoService';

export interface VideoListItem {
  id_video: string;
  nomeVideo: string;
  duration: number;
  frame: string;
  createdAt: string;
  totalViews: number;
  videoMP4?: string;
}

export function useVideos() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['videos', 'list', { limit: 200, sortBy: 'createdAt', sortOrder: 'DESC', includeFolderVideos: true }],
    queryFn: () => videoService.getVideosList({ limit: 200, sortBy: 'createdAt', sortOrder: 'DESC', includeFolderVideos: true }),
    staleTime: 1000 * 60 * 2,
  });

  const videos: VideoListItem[] = (data?.videos || []).map(v => ({
    id_video: v.id,
    nomeVideo: v.title,
    duration: v.duration,
    frame: v.thumbnailUrl || '',
    createdAt: v.createdAt,
    totalViews: v.views,
    videoMP4: v.videoDownload || undefined,
  }));

  return {
    videos,
    isLoading,
    error: error ? (error as Error).message : null,
  };
}
